// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IMedia {
  /** Ссылка на превью медиа **/
  previewUrl: string;
  /** Тип медиа (фото, видео, планировка) **/
  type: EType;
  /** Ссылка на медиа **/
  url: string;
  /** ID медиа **/
  id?: TMedia_Id;
  /** Конкретный тип видео (только для type='video') **/
  videoType?: TMedia_VideoType;
}

export enum EType {
  /** Планировка **/
  'Layout' = 'layout',
  /** Фото **/
  'Photo' = 'photo',
  /** Видео **/
  'Video' = 'video',
}
export type TMedia_Id = null | string;

export type TMedia_VideoType = null | EVideoType;

export enum EVideoType {
  /** Видео из Kinescope **/
  'Kinescope' = 'kinescope',
  /** Видео из Rutube **/
  'Rutube' = 'rutube',
  /** Видео из VK **/
  'Vk' = 'vk',
  /** Видео с youtube.com **/
  'Youtube' = 'youtube',
}
